import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Form, Modal, Select, Space, Spin, Table, Typography } from 'antd';
import { Box, Grid } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import { apiEndpoints } from '../../../config';
import { Crypter } from '../../../Functions/Security/Crypter';
import { SettingOutlined, CheckSquareOutlined, CloseSquareOutlined } from '@ant-design/icons';
import InputForm from '../../InputT';
import SearchModal from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import PCEMF from '../../../Models/PCEMF';

let searchCtegoCli: ParamsPicklist = { CodeAgence: 'TYPCLI', Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
let searchCtegoCpt: ParamsPicklist = { CodeAgence: 'CATEGOCPT', Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
let searchTypCPT: ParamsPicklist = { CodeAgence: 'TYPCPT', Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
let searchTypSens: ParamsPicklist = { CodeAgence: 'SENSEC', Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
let searchTypInt: ParamsPicklist = { CodeAgence: '', Table: 'COMMIS', Colonne1: 'CODCOM', Colonne2: 'LIBELL', Colagence: '101', Choix: 22 };

interface BatchItem {
  IDPLAN: string;
  LIBELL: string;
  TYPCPT: string;
  TYPCLI: string;
  categocpt: string;
  codprod: string;
  codage: string;
  sensSolde: string;
  NIVDEB: number;
  NIVCRE: number;
  DURVIE: number;
  SOLMIN: number;
  SOLMAX: number;
  TYPCPT2: string;
  CALINT: string;
  TXCRED: number;
  TXDEBI: number;
  TYPIN1: string;
  Niveau?: number;
}

const NUMBER_FIELDS = ['NIVDEB', 'NIVCRE', 'DURVIE', 'SOLMIN', 'SOLMAX', 'TXCRED', 'TXDEBI'];

const FIELD_OPTIONS = [
  { value: 'TYPCPT', label: 'Type compte' },
  { value: 'TYPCLI', label: 'Type client' },
  { value: 'categocpt', label: 'Catégorie compte' },
  { value: 'codprod', label: 'Code produit' },
  { value: 'codage', label: 'Code agence' },
  { value: 'sensSolde', label: 'Sens solde' },
  { value: 'TYPCPT2', label: 'Type compte 2' },
  { value: 'CALINT', label: 'Calcul intérêts' },
  { value: 'TYPIN1', label: 'Type intérêts 1' },
  { value: 'NIVDEB', label: 'Niveau débit' },
  { value: 'NIVCRE', label: 'Niveau crédit' },
  { value: 'DURVIE', label: 'Durée vie' },
  { value: 'SOLMIN', label: 'Solde minimum' },
  { value: 'SOLMAX', label: 'Solde maximum' },
  { value: 'TXCRED', label: 'Taux crédit' },
  { value: 'TXDEBI', label: 'Taux débit' },
];

const getDefaultConfig = (user: any): Partial<BatchItem> => ({});

const buildBatchItem = (pcemf: PCEMF, user: any): BatchItem => ({
  ...getDefaultConfig(user),
  IDPLAN: pcemf.Code,
  LIBELL: pcemf.Libelle,
  Niveau: pcemf.Niveau,
} as BatchItem);

const formatNumberValues = (values: any): any => {
  const copy = { ...values };
  NUMBER_FIELDS.forEach(f => {
    if (copy[f] !== undefined) copy[f] = Number(copy[f]) || 0;
  });
  return copy;
};

const renderEditor = (field: string, formInstance: any) => {
  const defaultCode = formInstance ? formInstance.getFieldValue(field) : undefined;
  switch (field) {
    case 'TYPCPT':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Type compte'
          name='TYPCPT'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchTypCPT}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'TYPCLI':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Type client'
          name='TYPCLI'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchCtegoCli}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'categocpt':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Catégorie compte'
          name='categocpt'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchCtegoCpt}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'sensSolde':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Sens solde'
          name='sensSolde'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchTypSens}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'TYPIN1':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Type intérêts 1'
          name='TYPIN1'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchTypInt}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'NIVDEB':
      return <InputForm width={12} label='Niveau débit' type='number' name='NIVDEB' notRequired />;
    case 'NIVCRE':
      return <InputForm width={12} label='Niveau crédit' type='number' name='NIVCRE' notRequired />;
    case 'DURVIE':
      return <InputForm width={12} label='Durée vie' type='number' name='DURVIE' notRequired />;
    case 'SOLMIN':
      return <InputForm width={12} label='Solde minimum' type='number' name='SOLMIN' notRequired />;
    case 'SOLMAX':
      return <InputForm width={12} label='Solde maximum' type='number' name='SOLMAX' notRequired />;
    case 'TXCRED':
      return <InputForm width={12} label='Taux crédit' type='number' name='TXCRED' notRequired />;
    case 'TXDEBI':
      return <InputForm width={12} label='Taux débit' type='number' name='TXDEBI' notRequired />;
    case 'IDPLAN':
      return <InputForm width={12} label='ID Plan' type='text' name='IDPLAN' disabled notRequired />;
    case 'LIBELL':
      return <InputForm width={12} label='Libellé' type='text' name='LIBELL' noupercase notRequired />;
    default:
      return <InputForm width={12} label={field} type='text' name={field} notRequired />;
  }
};

const TabBatchPCEMF = forwardRef((_, ref) => {
  const authHeader = useAuthHeader();
  const auth = useAuthUser();
  const user = auth() as any;
  const [loading, setLoading] = useState(false);
  const [batchItems, setBatchItems] = useState<BatchItem[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [groupField, setGroupField] = useState<string>('TYPCPT');
  const [modalVisible, setModalVisible] = useState(false);
  const [modalItem, setModalItem] = useState<BatchItem | null>(null);
  const [form] = Form.useForm();
  const [groupForm] = Form.useForm();

  useImperativeHandle(ref, () => ({
    saveBatch: async (action: 'ECRASER' | 'MANQUANTS' | 'FUSIONNER') => {
      if (batchItems.length === 0) {
        SweetAlert.fire({ title: 'Aucune donnée', text: 'Aucun PCEMF à enregistrer.', icon: 'warning' });
        return;
      }
      setLoading(true);
      try {
        const items = batchItems.map(({ Niveau, ...rest }) => rest);
        const payload = { Action: action, Utilisateur: user?.coduti ?? user?.NomUser ?? 'ADMIN', Items: items };
        const cypher = Crypter.encrypt(JSON.stringify(payload));
        const res = await axios.post(apiEndpoints.createBatchPlanCp, JSON.stringify(cypher), {
          headers: { Authorization: authHeader(), 'Content-Type': 'application/json' }
        });
        const raw = JSON.parse(Crypter.decrypt(res.data));
        const decrypted = raw.Value ?? raw;
        if (decrypted.StatutCode === 200) {
          SweetAlert.fire({ title: 'Succès', text: decrypted.Message, icon: 'success' });
        } else {
          SweetAlert.fire({ title: 'Erreur', text: decrypted.Message, icon: 'error' });
        }
      } catch (ex: any) {
        SweetAlert.fire({ title: 'Erreur', text: ex.message, icon: 'error' });
      }
      setLoading(false);
    }
  }));

  useEffect(() => {
    groupForm.resetFields();
  }, [groupForm, groupField]);

  const loadPCEMF = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiEndpoints.pcemf}/Lire`, {
        headers: { Authorization: authHeader(), 'Content-Type': 'application/json' }
      });
      const raw = JSON.parse(Crypter.decrypt(res.data));
      const decrypted = raw.Value ?? raw;
      if (decrypted.StatutCode === 200) {
        const list: PCEMF[] = decrypted.Result?.Table || decrypted.Result || [];
        setBatchItems(list.map(p => buildBatchItem(p, user)));
      } else {
        SweetAlert.fire({ title: 'Erreur', text: decrypted.Message, icon: 'error' });
      }
    } catch (ex: any) {
      SweetAlert.fire({ title: 'Erreur', text: ex.message, icon: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    loadPCEMF();
  }, []);

  const selectAll = () => setSelectedRowKeys(batchItems.map(i => i.IDPLAN));
  const deselectAll = () => setSelectedRowKeys([]);

  const applyGroup = () => {
    if (selectedRowKeys.length === 0) {
      SweetAlert.fire({ title: 'Aucune sélection', text: 'Veuillez sélectionner au moins une ligne.', icon: 'warning' });
      return;
    }
    const rawValue = groupForm.getFieldValue(groupField);
    const isNumber = NUMBER_FIELDS.includes(groupField);
    const value = isNumber ? (Number(rawValue) || 0) : rawValue;
    if (value === undefined || value === null || value === '') {
      SweetAlert.fire({ title: 'Valeur vide', text: 'Veuillez renseigner une valeur à appliquer.', icon: 'warning' });
      return;
    }
    const count = selectedRowKeys.length;
    setBatchItems(prev => prev.map(item => selectedRowKeys.includes(item.IDPLAN) ? { ...item, [groupField]: value } : item));
    setSelectedRowKeys([]);
    groupForm.resetFields();
    SweetAlert.fire({
      title: 'Appliqué',
      text: `Champ ${groupField} mis à jour pour ${count} ligne(s).`,
      icon: 'success',
      timer: 1500,
      showConfirmButton: false
    });
  };

  const openConfig = (item: BatchItem) => {
    setModalItem(item);
    form.setFieldsValue(item);
    setModalVisible(true);
  };

  const handleSaveModal = () => {
    form.validateFields().then(values => {
      const formatted = formatNumberValues(values);
      setBatchItems(prev => prev.map(item => item.IDPLAN === modalItem?.IDPLAN ? { ...item, ...formatted } : item));
      setModalVisible(false);
    });
  };

  const columns = [
    { title: 'ID Plan', dataIndex: 'IDPLAN', key: 'IDPLAN', width: 120 },
    { title: 'Libellé', dataIndex: 'LIBELL', key: 'LIBELL', width: 260, ellipsis: true },
    { title: 'Niv.', dataIndex: 'Niveau', key: 'Niveau', width: 60 },
    { title: 'Type', dataIndex: 'TYPCPT', key: 'TYPCPT', width: 70 },
    { title: 'Client', dataIndex: 'TYPCLI', key: 'TYPCLI', width: 70 },
    { title: 'Catégorie', dataIndex: 'categocpt', key: 'categocpt', width: 90 },
    { title: 'Sens', dataIndex: 'sensSolde', key: 'sensSolde', width: 70 },
    { title: 'Produit', dataIndex: 'codprod', key: 'codprod', width: 90 },
    { title: 'Agence', dataIndex: 'codage', key: 'codage', width: 80 },
    {
      title: 'Action',
      key: 'actions',
      fixed: 'right' as const,
      width: 110,
      render: (_: any, record: BatchItem) => (
        <Button size='small' icon={<SettingOutlined />} onClick={() => openConfig(record)}>
          Config.
        </Button>
      ),
    },
  ];

  return (
    <div className='tabItem' >
      <Spin spinning={loading} size='large' tip='Traitement en cours...'>
        <Box width={"87%"}>
          {/* <Typography.Title level={5} style={{ color: '#0d4a70', marginBottom: 12 }}>
          Création batch via PCEMF
        </Typography.Title> */}

          <Box className='bordure1' style={{ marginBottom: 16, padding: 12 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box style={{ padding: 10, backgroundColor: 'rgba(17,101,153,0.06)', borderRadius: 8 }}>
                  <Typography.Text strong style={{ color: '#0d4a70', display: 'block', marginBottom: 8 }}>
                    Configuration groupée
                  </Typography.Text>
                  <Space direction='vertical' size='small' style={{ width: '100%' }}>
                    <Space wrap style={{ width: '100%' }}>
                      <Button icon={<CheckSquareOutlined />} onClick={selectAll} size='small'>
                        Tout sélectionner
                      </Button>
                      <Button icon={<CloseSquareOutlined />} onClick={deselectAll} size='small'>
                        Tout désélectionner
                      </Button>
                      <Typography.Text type='secondary' style={{ marginLeft: 12 }}>
                        {selectedRowKeys.length} / {batchItems.length} sélectionné(s)
                      </Typography.Text>
                    </Space>

                    <Space wrap align='center' style={{ width: '100%' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <Typography.Text strong style={{ minWidth: 50 }}>Champ :</Typography.Text>
                        <Select
                          style={{ width: 170 }}
                          size='large'
                          value={groupField}
                          onChange={setGroupField}
                          options={FIELD_OPTIONS}
                        />
                        <Form form={groupForm} layout='inline' style={{ display: 'inline-flex', alignItems: 'center' }}>
                          <div style={{ minWidth: 200 }}>
                            {renderEditor(groupField, groupForm)}
                          </div>
                        </Form>
                        <Button type='primary' size='large' onClick={applyGroup} disabled={selectedRowKeys.length === 0} style={{ marginLeft: 16 }}>
                          Appliquer
                        </Button>
                      </div>
                    </Space>
                  </Space>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box className='bordure1' style={{ padding: 12 }}>
            <Table
              rowSelection={{ selectedRowKeys, onChange: setSelectedRowKeys }}
              dataSource={batchItems}
              columns={columns}
              rowKey='IDPLAN'
              size='small'
              tableLayout='fixed'
              scroll={{ x: 'max-content', y: 320 }}
            />
          </Box>

          <Modal
            title={`Configuration minimal - ${modalItem?.IDPLAN}`}
            open={modalVisible}
            onOk={handleSaveModal}
            onCancel={() => setModalVisible(false)}
            width={900}
            okText='Appliquer'
          >
            {modalItem && (
              <Form form={form} layout='vertical' initialValues={modalItem}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    {renderEditor('IDPLAN', form)}
                    {renderEditor('LIBELL', form)}
                    {renderEditor('TYPCPT', form)}
                    {renderEditor('TYPCLI', form)}
                    {renderEditor('categocpt', form)}
                    {renderEditor('codprod', form)}
                    {renderEditor('codage', form)}
                    {renderEditor('sensSolde', form)}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    {renderEditor('NIVDEB', form)}
                    {renderEditor('NIVCRE', form)}
                    {renderEditor('DURVIE', form)}
                    {renderEditor('SOLMIN', form)}
                    {renderEditor('SOLMAX', form)}
                    {renderEditor('TYPCPT2', form)}
                    {renderEditor('CALINT', form)}
                    {renderEditor('TXCRED', form)}
                    {renderEditor('TXDEBI', form)}
                    {renderEditor('TYPIN1', form)}
                  </Grid>
                </Grid>
              </Form>
            )}
          </Modal>
        </Box>
      </Spin>
    </div>
  );
});

export default TabBatchPCEMF;
